import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";
import { useDismissable } from "@common/hooks/useDismissable";

export function useUpgradeCart() {
    let { data: isFullyUpgraded } = useDotLegalQueryWithKey<boolean>("fullyUpgraded", "/plan/fullyUpgraded/");

    const { visible: showUpgradeBox, onDismiss: onHideUpgradeBox } = useDismissable("upgrade-plan-card-dismissed", 14, !(isFullyUpgraded ?? true));

    return { onHideUpgradeBox, showUpgradeBox };
}
